import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { useCurrentPage } from '»utils/customHooks';

import { ButtonGridStyled } from '../Styles/Buttons.styles';

export const ButtonClose = ({ disabled, onClick, isCard, hide, ...rest }) => {
  const { isStockExchangeOrdersDetailsPage } = useCurrentPage();

  return (
    <ButtonGridStyled
      location={
        isCard ? 'card' : isStockExchangeOrdersDetailsPage ? 'orderDetails' : ''
      }
      disabled={disabled}
      onClick={onClick}
      hide={hide}
      {...rest}
    >
      <FontAwesomeIcon
        icon={faClose}
        style={{
          fontSize:
            isCard || isStockExchangeOrdersDetailsPage ? '22px' : '16px',
        }}
      />
    </ButtonGridStyled>
  );
};

ButtonClose.propTypes = {
  disabled: PropTypes.bool,
  isCard: PropTypes.bool,
  onClick: PropTypes.func,
  hide: PropTypes.bool,
};
